<template>
  <div class="wrapper">
    <Tabs
      v-if="$route.name !== 'order-details'"
      v-model="activeTab"
      @input="changeTab"
      class="empty-tab"
    >
      <Tab
        :key="`tab-${index}`"
        v-for="(item, index) of authorizedTabs"
        :header="item.label"
      >
      </Tab>
    </Tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Liste",
          name: "orders-list",
          requiredPermission: "ORDERS_READ",
        },
        {
          label: "Cartes",
          name: "orders-maps",
          requiredPermission: "ORDERS_READ",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return Array.isArray(tab.requiredPermission)
          ? tab.requiredPermission.some((permission) =>
              this.hasPermission(this.$store.state.user, permission),
            )
          : this.hasPermission(this.$store.state.user, tab.requiredPermission);
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) =>
          tab.name === currentPath || tab.children?.includes(currentPath),
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>

<style lang="scss">
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  & > .tab-content {
    display: none;
  }
}

.display-tab {
  .tab-content {
    display: block !important;
  }
}
</style>
